import { FC } from 'react';
import Svg, { SvgProps } from '@/components/shared/Svg/Svg.tsx';

const Default: FC<Omit<SvgProps, 'children'>> = (props) => {
  return (
    <Svg viewBox="0 0 400 150" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        {/* Logo "P" from Figma */}
        <g transform="translate(20, 2)">
          <path
            d="M12.2282 1.55225V144.927M24.1642 1.55225V144.927M36.1002 1.55225V144.927M46.7762 145.503H1.55225V2.05491H46.7762V145.503ZM46.7762 108.292C74.4322 108.292 96.8536 85.8735 96.8536 58.2162C96.8536 30.5615 74.4322 8.14158 46.7762 8.14158V108.292ZM47.2136 94.6749C67.3496 94.6749 83.6722 78.3522 83.6722 58.2162C83.6722 38.0815 67.3496 21.7589 47.2136 21.7589V94.6749ZM47.2136 81.2495C59.9336 81.2495 70.2469 70.9375 70.2469 58.2162C70.2469 45.4962 59.9336 35.1856 47.2136 35.1856V81.2495ZM47.2136 67.6082C52.4002 67.6082 56.6056 63.4029 56.6056 58.2162C56.6056 53.0295 52.4002 48.8255 47.2136 48.8255V67.6082Z"
            stroke="#FFFFFF"
            strokeWidth="3.10467"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </g>

        {/* Text "Past Paper Plus" */}
        <text x="140" y="85" fontFamily="Varela Round, sans-serif" fontSize="28" fontWeight="400" fill="#FFFFFF">
          Past Papers Plus
        </text>
      </g>
    </Svg>
  );
};

const LogoOnly: FC<Omit<SvgProps, 'children'>> = (props) => {
  return (
    <Svg viewBox="0 0 99 148" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        {/* Logo "P" from Figma */}
        <path
          d="M12.2282 1.55225V144.927M24.1642 1.55225V144.927M36.1002 1.55225V144.927M46.7762 145.503H1.55225V2.05491H46.7762V145.503ZM46.7762 108.292C74.4322 108.292 96.8536 85.8735 96.8536 58.2162C96.8536 30.5615 74.4322 8.14158 46.7762 8.14158V108.292ZM47.2136 94.6749C67.3496 94.6749 83.6722 78.3522 83.6722 58.2162C83.6722 38.0815 67.3496 21.7589 47.2136 21.7589V94.6749ZM47.2136 81.2495C59.9336 81.2495 70.2469 70.9375 70.2469 58.2162C70.2469 45.4962 59.9336 35.1856 47.2136 35.1856V81.2495ZM47.2136 67.6082C52.4002 67.6082 56.6056 63.4029 56.6056 58.2162C56.6056 53.0295 52.4002 48.8255 47.2136 48.8255V67.6082Z"
          stroke="#FFFFFF"
          strokeWidth="3.10467"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </Svg>
  );
};
export default {
  Default,
  LogoOnly,
};
